<template>
    <b-overlay :show="is_load" rounded="sm">
        <div class="zone_info">
            <div class="feature_info">
                <div class="row">
                    <div class="col-6">
                        <div class="form-group" v-if="obj_to_null(active_feature)">
                            <label class="form-label" for="basic-url">
                                {{__t('ZONE_COST')}}
                            </label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                            <span class="input-group-text" id="basic-addon3">
                                {{active_feature.id}}
                            </span>
                                </div>
                                <input type="number" v-model="feature_cost" class="form-control" id="basic-url" aria-describedby="basic-addon3">
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group" v-if="obj_to_null(active_feature)">
                            <label class="form-label" for="basic-url">
                                {{__t('ZONE_TIME')}}
                            </label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                            <span class="input-group-text" id="basic-addon4">
                                {{active_feature.id}}
                            </span>
                                </div>
                                <input type="number" v-model="feature_time" class="form-control" id="basic-url4" aria-describedby="basic-addon3">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="rest_zones">
            <div ref="map" class="map"></div>
        </div>
    </b-overlay>

</template>

<script>
    import mapboxgl from "mapbox-gl";
    import MapboxDraw from "@mapbox/mapbox-gl-draw";

    let draw = new MapboxDraw({
        displayControlsDefault: false,
        controls: {
            polygon: true,
            trash: true,
            defaultMode: 'draw_polygon',
            userProperties: true,
        },
    });
    mapboxgl.accessToken = "pk.eyJ1IjoibG9payIsImEiOiJjamh6dnF4cGwwM3JtM3BwaTg4b28zNXdhIn0.OvClW1t-Lxss_VhXQHBAwQ";
    const MAP_STYLE = "mapbox://styles/mapbox/light-v10";

    export default {
        name: "restaurant_zone",
        props : {
            rest : {
                type : Object
            }
        },
        data() {
            return {
                is_load: true,
                map_loaded : false,
                active_feature : null,
                to_save_features : [],
            }
        },
        created () {
            EventBus.$on('rest_tab', (idx) => {
                if (idx !== 4) return;

                this.$nextTick(() => {
                    setTimeout(() => {
                        this.initMap();
                        if (this.map) this.map.resize();
                    }, 50);
                });
            });


           /* EventBus.$on('rest_tab',idx=> {
                let self = this;
                if (idx === 3) {
                    this.$nextTick(() => {
                        this.is_load = true;
                        setTimeout(() => {
                            this.map.resize();
                            this.is_load = false;
                        }, 100);
                    });
                }
            });*/
        },

        mounted() {
            /*this.map = new mapboxgl.Map({
                container: "map",
                style: MAP_STYLE,
                // Note: deck.gl will be in charge of interaction and event handling
                // interactive: ,
                center: this.map_center,
                zoom: 10,
            });

            let self = this;
            this.map.on("load", function () {
                self.map.addControl(draw, "top-left");
                self.map_loaded = true;
                self.attach_zones();
                self.map.resize();
                self.is_load = false;

                self.updateArea({});
            });

            self.map.on('draw.selectionchange',function(e) {
                let features = e.features;
                if(features.length > 1) {
                    EventBus.$emit('show_toast', {
                        err: "ERR",
                        type: "danger",
                        title: self.__t('MULTIPLE_SELECT_NOT_ALLOWED'),
                        position : "b-toaster-top-left"
                    })
                }
                let cut_feature = features[0];
                self.active_feature = cut_feature;
            });

            self.map.on('draw.create', this.updateArea);
            self.map.on('draw.delete', this.updateArea);
            self.map.on('draw.update', this.updateArea);
*/

        },

        methods : {


                initMap() {
                    if (this.map) return;              // уже создана
                    if (!this.$el || !this.$el.offsetParent) return; // всё ещё скрыта

                    this.is_load = true;

                    this.map = new mapboxgl.Map({
                        container: this.$refs.map, // важно: ref, не id
                        style: MAP_STYLE,
                        center: this.map_center,
                        zoom: 10,
                    });

                    this.map.on("load", () => {
                        this.map.addControl(draw, "top-left");
                        this.map_loaded = true;
                        this.attach_zones();
                        this.updateArea({});
                        this.is_load = false;
                        this.map.resize();
                    });

                    this.map.on("draw.selectionchange", (e) => {
                        if (e.features.length > 1) {
                            EventBus.$emit('show_toast', {
                                err: "ERR",
                                type: "danger",
                                title: this.__t('MULTIPLE_SELECT_NOT_ALLOWED'),
                                position: "b-toaster-top-left"
                            })
                        }
                        this.active_feature = e.features[0] || null;
                    });

                    this.map.on('draw.create', this.updateArea);
                    this.map.on('draw.delete', this.updateArea);
                    this.map.on('draw.update', this.updateArea);
                },



            updateArea(e) {
                let features = draw.getAll();
                if (features.hasOwnProperty('features')) {
                    features.features.map(feature => {
                        let has_stored = this.get_stored_feature(feature.id);
                        console.log('has_stored', has_stored);
                        feature.cost = 0;
                        feature.time = 0;
                        if (has_stored) {
                            feature.cost = has_stored.cost;
                            feature.time = has_stored.time;
                        }
                    });
                }
                this.rest.delivery_zones = features;
            },

            get_stored_feature(id) {

                let stored = null;
                if(this.rest.hasOwnProperty('zones') && this.rest.zones.length > 0) {
                    this.rest.zones.map(item => {
                        if(item.feature.id == id) {
                            stored = item;
                        }
                    })
                }
                return stored;
            },

            attach_zones() {
                if (!this.rest?.zones?.length) return;

                const fc = { type: "FeatureCollection", features: [] };

                this.rest.zones.forEach(z => {
                    const f = z.feature;

                    f.properties = f.properties || {};
                    f.properties.zone_id = z.id;
                    f.properties.cost = z.cost ?? 0;
                    f.properties.time = z.time ?? 0;

                    fc.features.push(f);
                });

                draw.add(fc);
            }
        },

        computed : {

            map_center() {
                let default_center =[30.511092299999973,50.46037159999999];

                if (this.rest.hasOwnProperty("lat") && this.rest.hasOwnProperty("lng")) {
                    const lat = parseFloat(this.rest.lat);
                    const lng = parseFloat(this.rest.lng);

                    if (isFinite(lat) && isFinite(lng) && lng > 0) {
                        return [lng, lat];
                    }
                }

                return default_center;
            },

            rest_feature () {
                if(this.rest.hasOwnProperty('delivery_zones')) {
                    return this.rest.delivery_zones;
                }
                return null;
            },

            rest_features () {
                if(this.rest_feature) {
                    return this.rest_feature.features;
                }
                return [];
            },

            feature_time : {
                get: function () {
                    try {
                        let in_zone = {
                            'time' : 0
                        };
                        let cur_id = this.active_feature.id;
                        this.rest_features.map(item => {
                            if(item.id == cur_id) {
                                in_zone = item;
                            }
                        });

                        return in_zone.time;
                    }
                    catch (e) {

                    }
                    return null;
                },
                set: function (newValue) {

                    let in_zone = null;
                    let cur_id = this.active_feature.id;
                    this.rest_features.map(item => {
                        if(item.id == cur_id) {
                            in_zone = item;
                        }
                    });

                    if(in_zone) {
                        in_zone.time = newValue;
                    }
                }
            },

            feature_cost : {
                get: function () {
                    try {
                        let in_zone = {
                            'cost' : 0
                        };
                        let cur_id = this.active_feature.id;
                        this.rest_features.map(item => {
                            if(item.id == cur_id) {
                                in_zone = item;
                            }
                        });

                        return in_zone.cost;
                    }
                    catch (e) {

                    }
                    return null;
                },
                set: function (newValue) {

                    let in_zone = null;
                    let cur_id = this.active_feature.id;
                    this.rest_features.map(item => {
                        if(item.id == cur_id) {
                            in_zone = item;
                        }
                    });

                    if(in_zone) {
                        in_zone.cost = newValue;
                    }
                }
            }
        }
    }
</script>

<style scoped>
.rest_zones { height: 60vh; min-height: 500px; }
.map { width: 100%; height: 100%; }
</style>
